import { slugify } from "../../../utils/string";
import { sortByDistance } from "../../../utils/sortByDistance";

const filterBehaviour = (
  filteredData,
  filterState,
  filterKeys,
  setFilteredEntities,
  searchState,
  mapref = null,
  selectedGeoAdress
) => {
  //------------- Check if state is not empty so the filter doesn't trigger

  const isStateFilled = () => {
    for (const key in filterState) {
      if (filterState[key].length > 0) {
        return true;
      }
    }
    return false;
  };


  const createSlug = (string) => {
    return string
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '_')
      .replace(/-+/g, '_');
  }


  function areEqual(array1, array2) {
    if (array1.length === array2.length) {
      return array1.every((element, index) => {
        if (element === array2[index]) {
          return true;
        }
        return false;
      });
    }
    return false;
  }

  if (isStateFilled()) {
    let tempFilteredData = [];

    // custom filter monDelta
    const filterNameButtonType = "filter"
    const filterNameBudgetMin = "budget_min"
    const filterNameBudgetMax = "budget_max"
    const entityNamePrice = "price_slug"

    //----Construction du tableau de tableau d'entité(s) qui correspond(ent) aux filtres sélectionnés
    for (const key in filterState) {
      if (filterState[key].length > 0) {
        tempFilteredData = [
          ...tempFilteredData,
          filteredData.filter((entity) => {
            if ((filterNameBudgetMin === key || filterNameBudgetMax === key) && entity[entityNamePrice].length > 0) {
              const priceEntity = parseFloat(entity[entityNamePrice][0].replace(/\s/g, ''));
              let priceInput = parseFloat(filterState[key][0]);
              if( filterState[filterNameBudgetMax] === 0 && key === filterNameBudgetMax) return true
              
              return filterNameBudgetMin === key ? priceInput <= priceEntity : priceInput >= priceEntity;
            }           
            if (!entity[key] || key === 'town') {
              return true
            }
            return entity[key].some((item) => {
              if (filterNameButtonType === key && filterState[key][0] === "all") {
                return true
              } else {
                return filterState[key].includes(item)
              }
            })
          }
          ),
        ];
      }
    }


    //--- Filter entity depending on the selected filters, flat the data and only keep the entities that are in all tempFiltederData subArray
    if (tempFilteredData.length > 1) {
      let flatData = tempFilteredData.flat();
      let necklaceFilteredData = [];
      for (const data of flatData) {
        let tempArray = flatData.filter((elt) => data.id === elt.id);
        if (
          tempArray.length === tempFilteredData.length &&
          !necklaceFilteredData.find((element) => element.id === data.id)
        ) {
          necklaceFilteredData.push(data);
        }
      }
      // if (searchState) {
      //   let tempArray = [];
      //   for (const data of necklaceFilteredData) {
      //     if (
      //       slugify(data.name).includes(slugify(searchState)) ||
      //       slugify(data?.address).includes(slugify(searchState)) ||
      //       slugify(data.regions[0]).includes(slugify(searchState))
      //     ) {
      //       tempArray.push(data);
      //     }
      //   }
      //   setFilteredEntities(tempArray);
      // } else {
      if (selectedGeoAdress) {
        necklaceFilteredData = sortByDistance(
          selectedGeoAdress,
          necklaceFilteredData
        );
      }
      setFilteredEntities(necklaceFilteredData);

      // }

      return null;
    } else {
      let tempArray = [];
      let flatData = tempFilteredData.flat();
      // if (searchState) {
      // for (const data of flatData) {
      //   if (
      //     slugify(data.name).includes(slugify(searchState)) ||
      //     slugify(data?.address).includes(slugify(searchState)) ||
      //     slugify(data.regions[0]).includes(slugify(searchState))
      //   ) {
      //     tempArray.push(data);
      //   }
      // }
      // setFilteredEntities(tempArray);
      // } else {

      if (selectedGeoAdress) {
        flatData = sortByDistance(selectedGeoAdress, flatData);
      }
      setFilteredEntities(flatData);
      // }
      return null;
    }
  } else {
    let tempArray = [];
    // if (searchState) {
    //   for (const data of filteredData) {
    //     if (
    //       slugify(data.name).includes(slugify(searchState)) ||
    //       slugify(data?.address).includes(slugify(searchState)) ||
    //       slugify(data.regions[0]).includes(slugify(searchState))
    //     ) {
    //       tempArray.push(data);
    //     }
    //   }
    //   setFilteredEntities(tempArray);
    // } else {
    if (selectedGeoAdress) {
      let sortedData = [...filteredData];
      sortedData = sortByDistance(selectedGeoAdress, sortedData);
      setFilteredEntities(sortedData);
    } else {
      setFilteredEntities(filteredData);
    }
    // }
    return null;
  }
};

export default filterBehaviour;
